export enum FileUploadStatus {
  Enqueued = 1,
  InProgress = 2,
  Completed = 3,
  Failed = 4,
  Aborted = 5,
}
